/* Dawn cart API adapter */
(function () {
  'use strict';

  if (window.DDCartApi) return;

  function json(url, options) {
    return fetch(url, options || {}).then(function (response) {
      if (!response.ok) throw new Error('Cart API error: ' + response.status);
      return response.json();
    });
  }

  window.DDCartApi = {
    getCart: function () {
      return json('/cart.js', { credentials: 'same-origin' });
    },
    add: function (id, quantity, sections) {
      var body = { items: [{ id: id, quantity: quantity || 1 }] };
      if (sections) body.sections = sections;
      return json('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
    },
    update: function (updates, sections) {
      var body = { updates: updates || {} };
      if (sections) body.sections = sections;
      return json('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
    },
    change: function (line, quantity, sections) {
      var body = { line: line, quantity: quantity };
      if (sections) body.sections = sections;
      return json('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
    },
  };
})();
